import { render, staticRenderFns } from "./MainCallIcon.vue?vue&type=template&id=433a395a&scoped=true&"
import script from "./MainCallIcon.vue?vue&type=script&lang=js&"
export * from "./MainCallIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "433a395a",
  null
  ,true
)

export default component.exports